import { ReactNode, useId } from "react";
import Drawer from "@mui/material/Drawer";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { IconButton } from "../IconButton";
import { useNextT } from "../../i18n";
import { ToastHost, useToastAvoid } from "../Toast";
import s from "./SideSheet.module.scss";

/** Filters panel. `anchor="right"` = inline END: the RTL theme mirrors it — never flip it here. */
export const SideSheet = ({ open, title, onClose, children, footer, headerAction }: { open: boolean; title: string; onClose: () => void; children: ReactNode; footer?: ReactNode; headerAction?: ReactNode }) => {
  const { t } = useNextT();
  const id = useId();
  const avoid = useToastAvoid();
  return (
    <Drawer anchor="right" open={open} onClose={onClose} className="cy-next" PaperProps={{ className: s.paper, role: "dialog", "aria-labelledby": id } as any}>
      <header className={s.head}>
        <h2 id={id} className={s.title}>{title}</h2>
        <div className={s.headEnd}>
          {headerAction}
          <IconButton label={t("ui.close")} icon={<CloseRoundedIcon />} onClick={onClose} />
        </div>
      </header>
      <div className={s.body}>{children}</div>
      {footer && <footer ref={avoid} className={s.foot}>{footer}</footer>}
      <ToastHost active={open} />
    </Drawer>
  );
};
